export default function sortBy<T>(arr: T[], keyOf: (item: T)=> string): T[] {
  return arr.sort((a, b) => {
    const aUpper = keyOf(a).toUpperCase()
    const bUpper = keyOf(b).toUpperCase()

    return aUpper < bUpper ? -1 : aUpper > bUpper ? 1 : 0
  })
}
